import { render, staticRenderFns } from "./InactiveView.vue?vue&type=template&id=4a7c4839&"
import script from "./InactiveView.vue?vue&type=script&lang=js&"
export * from "./InactiveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports